import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UnknownOpcoHandlerComponent } from '@app/components/unknown-opco-handler/unknown-opco-handler.component';
import { ErrorInterceptor } from '@common/interceptor/back-error.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { defineCustomElements } from '@mateco/zenith-webcomponents/loader';
import { AcceptLanguageHeaderInterceptor } from '@common/interceptor/accept-language-header.interceptor';
import { registerLocaleData } from '@angular/common';
import localeCS from '@angular/common/locales/cs';
import localeHU from '@angular/common/locales/hu';
import localeNL from '@angular/common/locales/nl';
import localePL from '@angular/common/locales/pl';
import localeES from '@angular/common/locales/es';
import localeFR from '@angular/common/locales/fr';
import localeDE from '@angular/common/locales/de';
import { AppComponent } from './app.component';
import * as Sentry from '@sentry/angular';
import { provideZenithInspector } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { provideAuthentication } from '@app/shared/qplanning-commons/auth/provide-authentication';

export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './_ng/translations/', '.json');
}

registerLocaleData(localeES);
registerLocaleData(localeNL);
registerLocaleData(localeCS);
registerLocaleData(localeHU);
registerLocaleData(localeDE);
registerLocaleData(localeFR);
registerLocaleData(localePL);

@NgModule({
  declarations: [AppComponent, UnknownOpcoHandlerComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      /* only enabled when packed version of app; ignored during local development */
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AcceptLanguageHeaderInterceptor,
      multi: true,
    },
    provideZenithInspector(!environment.production),
    provideHttpClient(withInterceptorsFromDi()),
    provideAuthentication()
  ]
})
export class AppModule {
  constructor() {
    defineCustomElements();
  }
}
